module.exports = __webpack_public_path__ + "img/lovehome.2ea1fab2.jpg";